module.exports = __webpack_public_path__ + "static/img/milk.33f43f85.png";